export default __webpack_public_path__ + "static/media/dark-code.9f2a56be.svg";